import React from 'react'

import { SH4 } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { useUserContext } from '@zet/feature-user'

import { useReturnUrl } from '../../hooks/useReturnUrl'
import DsaLogo from './dsaLogo'

const RightSideElement = () => {
  const { url } = useReturnUrl()
  const { data } = useUserContext()

  const navigateToReturnUrl = () => {
    window.location.href = url
  }

  if (url) {
    if (data?.companyName) {
      return (
        <Pressable
          className="border-primary-100 ml-4 max-w-[150px] flex-1 items-center justify-center self-end rounded-sm border bg-white p-2"
          onPress={navigateToReturnUrl}
          eventName="click_action"
          eventPayload={{ item_name: 'home_page_start_selling' }}
        >
          <SH4
            numberOfLines={2}
            className="text-primary-100"
          >{`Back to Home Page`}</SH4>
        </Pressable>
      )
    }
    return <></>
  }
  return <DsaLogo />
}

export { RightSideElement }
